import { createEffect, type Effect } from 'effector'
import type { GenericApiResponse } from '../../interfaces/generic'
import type { OVPChannelOwners } from './index.h'

export type { OVPChannelOwners }

export const setChannelOwnerDataFx: Effect<
  OVPChannelOwners,
  void,
  GenericApiResponse<Error>
> = createEffect()
